export const RUN_TESTS = false;
